let captchaLoading = false;

export const loadCaptcha = () => {
    return new Promise(resolve => {
        if (!window.grecaptcha && !captchaLoading) {
            captchaLoading = true;
            const script = document.createElement('script');
            script.setAttribute(
                'src',
                `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_KEY}`
            );
            document.body.appendChild(script);
        }

        const interval = setInterval(() => {
            if (window.grecaptcha) {
                clearInterval(interval);
                resolve(window.grecaptcha);
            }
        }, 500);
    });
};

export const getCaptcha = action => {
    return new Promise(resolve => {
        loadCaptcha().then(grecaptcha => {
            grecaptcha.ready(() => {
                grecaptcha.execute(process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_KEY, { action }).then(token => {
                    resolve(token);
                });
            });
        });
    });
};
